/**
 * Firebase initialization for JD Simplified.
 *
 * Firebase Auth replaces Supabase Auth. Firebase UIDs = Supabase UUIDs.
 * PostgREST verifies Firebase JWTs via JWKS; auth.uid() reads JWT sub claim.
 */

import { initializeApp } from 'firebase/app';
import {
  getAuth,
  initializeAuth,
  indexedDBLocalPersistence,
  connectAuthEmulator,
} from 'firebase/auth';
import { Capacitor } from '@capacitor/core';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

if (!firebaseConfig.apiKey) {
  throw new Error('Missing VITE_FIREBASE_API_KEY environment variable');
}

const firebaseApp = initializeApp(firebaseConfig);

// On native (Capacitor WKWebView), getAuth()'s default init includes the
// browser popup/redirect resolver, whose hidden authDomain iframe never
// completes on the capacitor:// scheme — auth init hangs forever and every
// sign-in times out. initializeAuth without a resolver skips redirect
// resolution entirely (native uses email/password only). Web keeps getAuth().
export const firebaseAuth = Capacitor.isNativePlatform()
  ? initializeAuth(firebaseApp, { persistence: indexedDBLocalPersistence })
  : getAuth(firebaseApp);

// Connect to emulator in development if configured
if (import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST) {
  connectAuthEmulator(firebaseAuth, import.meta.env.VITE_FIREBASE_AUTH_EMULATOR_HOST);
}
